import { render, staticRenderFns } from "./AuthLoginRedirectPage.vue?vue&type=template&id=6179f2c4&scoped=true"
import script from "./AuthLoginRedirectPage.vue?vue&type=script&lang=ts"
export * from "./AuthLoginRedirectPage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6179f2c4",
  null
  
)

export default component.exports